var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04778 2.01062C8.49256 2.01062 8.04247 2.46071 8.04247 3.01593H14.0743C14.0743 2.46071 13.6242 2.01062 13.069 2.01062H9.04778ZM3.01593 5.02654C2.46071 5.02654 2.01062 5.47663 2.01062 6.03185V7.03716H3.00932C3.01433 7.03712 3.01932 7.03712 3.02431 7.03716H19.0925C19.0975 7.03712 19.1025 7.03712 19.1075 7.03716H20.1062V6.03185C20.1062 5.47663 19.6561 5.02654 19.1009 5.02654H3.01593ZM20.0519 9.04778H22.1168V6.03185C22.1168 4.3662 20.7665 3.01593 19.1009 3.01593H16.0849C16.0849 1.35028 14.7347 0 13.069 0H9.04778C7.38213 0 6.03185 1.35028 6.03185 3.01593H3.01593C1.35028 3.01593 0 4.3662 0 6.03185V9.04778H2.06492L2.96472 25.2442C3.02391 26.3097 3.90514 27.1433 4.97224 27.1433H17.1445C18.2116 27.1433 19.0929 26.3097 19.1521 25.2442L20.0519 9.04778ZM18.0382 9.04778H4.07863L4.97224 25.1327H17.1445L18.0382 9.04778ZM9.04778 12.0637C9.60299 12.0637 10.0531 12.5138 10.0531 13.069V21.1115C10.0531 21.6667 9.60299 22.1168 9.04778 22.1168C8.49256 22.1168 8.04247 21.6667 8.04247 21.1115V13.069C8.04247 12.5138 8.49256 12.0637 9.04778 12.0637ZM13.069 12.0637C13.6242 12.0637 14.0743 12.5138 14.0743 13.069V21.1115C14.0743 21.6667 13.6242 22.1168 13.069 22.1168C12.5138 22.1168 12.0637 21.6667 12.0637 21.1115V13.069C12.0637 12.5138 12.5138 12.0637 13.069 12.0637Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTrash);
export default ForwardRef;